<template>
  <form class="cta-form row">
    <div
      class="cta-block-item row col s12 valign-wrapper"
      :class="props.data.actionBtns.parentClasses"
    >
      <template
        v-if="canCustomize"
      >
        <div
          v-if="props.data.actionBtns.customize.enable"
          :class="props.data.actionBtns.customize.parentClasses"
          class="btn-holder"
        >
          <NuxtLink
            :to="`/designer?product-id=${props.productData.id}${props.options.addonsInOrder.length ? '&addons=' + props.options.addonsInOrder.join(',') : ''}${objectToUrlParams(query) ? '&' + objectToUrlParams(query) : ''}`"
            class="btn waves-effect waves-light"
            :class="props.data.actionBtns.customize.buttonClasses"
          >
            {{ props.data.actionBtns.customize.buttonTitle }}
          </NuxtLink>

          <span
            v-if="props.data.actionBtns.customize.showDescr"
            class="tiny"
            v-html="$t('customizeNowDescr', { count: props.data.productOrderMax })"
          ></span>
        </div>

        <div
          class="btn-separate small"
          :class="{ subDescr: props.data.actionBtns.customize.showDescr || props.data.actionBtns.quote.showDescr || props.data.actionBtns.contactAdvisor.showDescr }"
        >
          {{ $t('or') }}
        </div>
      </template>

      <template
        v-if="canAddToCart"
      >
        <div
          class="btn-holder small flex justify-center items-center lg:justify-start lg:items-start"
          :class="props.data.actionBtns.addToCart.parentClasses"
        >
          <Button
            size="large"
            :class="[ props.data.actionBtns.addToCart.buttonClasses, {'loading': loadingForm} ]"
            icon="icon icon-e-add"
            :disabled="loadingForm"
            :label="$member?.isMember?.value
              ? $t('addToMyGiftsBtn') 
              : $t('addToCart')"
            class="w-max px-8"
            @click="() => { 
              if ($member?.isMember?.value) {
                addToProjectsFunct()
              } else { 
                drawerOptions.entry = {
                  typeId: 'entry',
                  componentId: 'WidgetsSystemEntry',
                  header: $t('startGiftingToday'),
                  viewType: 'secondary',
                  buttons: false,
                  typeForm: 'register',
                  message: {
                    severity: 'info',
                    text: $t('logInToContinue')
                  },
                  returnData: () => {
                    addToProjectsFunct()
                  }
                }
              }
            }"
          >
          </Button>
        </div>

        <div
          v-if="props.data.actionBtns.addToCart.separate?.enable && (canContactAdvisor || canQuote)"
          class="btn-separate small"
          :class="props.data.actionBtns.addToCart.separate?.elementClasses"
        >
          {{ $t('or') }}
        </div>
      </template>

      <div
        v-if="props.data.actionBtns.quote && props.data.actionBtns.quote.enable"
        :class="props.data.actionBtns.quote.parentClasses"
        class="btn-holder"
      >
        <NuxtLink
          :to="`/designer?product-id=${props.productData.id}&quote=true${props.options.addonsInOrder.length ? '&addons=' + props.options.addonsInOrder.join(',') : ''}${objectToUrlParams(query) ? '&' + objectToUrlParams(query) : ''}`"
          class="btn waves-effect waves-light quoteBtn"
          :class="props.data.actionBtns.quote.buttonClasses"
        >
          {{ props.data.actionBtns.quote.buttonTitle }}
        </NuxtLink>

        <span
          v-if="props.data.actionBtns.quote.showDescr"
          class="tiny"
          v-html="$t('quickQuoteDescr')"
        ></span>
      </div>

      <div
        v-if="canQuote"
        :class="props.data.actionBtns.shortQuote.parentClasses"
        class="btn-holder"
      >
        <button
          type="button"
          class="btn waves-effect waves-light quoteBtn"
          :class="props.data.actionBtns.shortQuote.buttonClasses"
          @click="drawerOptions.productQuote = (() => {
            return Object.assign({ 
              productData: props.productData,
              productSpecData: props.productSpecData
            }, props.data.actionBtns.shortQuote.options )
          })()"
        >
          {{ props.data.actionBtns.quote.buttonTitle }}
        </button>

        <span
          v-if="props.data.actionBtns.quote.showDescr"
          class="tiny"
          v-html="$t('quickQuoteDescr')"
        ></span>
      </div>

      <div
        v-if="canContactAdvisor"
        class="btn-holder"
        :class="props.data.actionBtns.contactAdvisor.parentClasses"
      >
        <button
          type="button"
          class="btn waves-effect waves-light quoteBtn"
          :class="(canCustomize || canAddToCart) && props.data.actionBtns.contactAdvisor.buttonClassesSecond
            ? props.data.actionBtns.contactAdvisor.buttonClassesSecond
            : props.data.actionBtns.contactAdvisor.buttonClasses"
          @click="drawerOptions.conversation = props.data.actionBtns.contactAdvisor.options"
        >
          {{ props.data.actionBtns.contactAdvisor.buttonTitle }}
        </button>

        <span
          v-if="props.data.actionBtns.contactAdvisor.showDescr"
          class="tiny"
          v-html="$t('quickQuoteDescr')"
        ></span>
      </div>
    </div>

    <template v-if="props.data.priceEnable">
      <div
        class="cta-sample-block row"
      >
        <div class="cta-sample col s12 valign-wrapper">
          <div
            v-if="props.data.shippingText"
            class="info grey lighten-3 col s9 valign-wrapper"
          >
            <strong
              class="grey-text small"
              v-html="props.data.shippingText"
            ></strong>
          </div>

          <div class="small price grey lighten-3 bold col s3 center">
            <span class="tiny grey-text text-lighten-1">
              {{ $t('price') }}:
            </span><br>

            <span class="primary-color-text text-base-2">
              {{ moneyFormat(props.data.price) }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </form>
</template>

<script setup>
const { query } = useRoute()
const { push: routerPush } = useRouter()
const { confServices } = useConfig()
// const { getCart, addToCart } = useCart()
const { drawerOptions } = usePopups()

const loadingForm = ref(false)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  },
  productData: {
    type: [Object],
    default: null
  },
  productSpecData: {
    type: [Object],
    default: null
  },
  options: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnForGtm'])

/**
* Can Add To Cart
*/
const canAddToCart = computed({
  get() {
    return props.options.settingsData.is_allow_add_to_cart
      && props.data.actionBtns?.addToCart?.enable
  }
})

/**
* Can Customized
*/
const canCustomize = computed({
  get () {
    return !canAddToCart.value && (props.options.settingsData.can_design || props.options.settingsData.can_edit)
      && !props.options.settingsData.is_quote_only
      && props.data.actionBtns?.customize?.enable
  }
})

/**
* Can Quote
*/
const canQuote = computed({
  get () {
    return !canAddToCart.value && props.data.actionBtns.shortQuote?.enable
  }
})

/**
* Can Contact Advisor
*/
const canContactAdvisor = computed({
  get () {
    return !(canAddToCart.value) && props.data.actionBtns.contactAdvisor && props.data.actionBtns.contactAdvisor.enable && confServices.typeform.enable 
  }
})


/*
* Add To Projects
*/
const addToProjectsFunct = async () => { 
  loadingForm.value = true

  /*
  * Default Params
  */
  const quantity = props.productSpecData.schema.quantity.order ? props.productSpecData.schema.quantity.order : 1

  /*
  * Send Request
  */
  await useAddToProjects({
    productId: props.productData.id,
    isStandard: true,
    quantity: quantity
  }).then(async () => { 
    // GTM - Add To Projects
    emit('returnForGtm', {
      event: 'add_to_projects',
      ecommerce: {
        currency: 'USD',
        value: props.productData.pre_populated_unit_price * quantity,
        items: [{
          index: 0,
          item_id: props.productData.id,
          item_name: props.productData.producttitle,
          price: props.productData.pre_populated_unit_price,
          quantity: quantity
        }]
      }
    })

    // Redirect
    routerPush('/customer/projects')

    loadingForm.value = false
  }).catch(() => {
    loadingForm.value = false
  })
}

/*
* Add To Cart
* WARN: This is not used in this component. 
* Now we use addToProjectsFunct
*/
// const addToCartFunct = async () => { 
//   loadingForm.value = true

//   /*
//   * Default Params
//   */
//   const quantity = props.productSpecData.schema.quantity.order ? props.productSpecData.schema.quantity.order : 1
 
//   const currentAttribute = props.productSpecData.data.attribute_values.order.find(n => n.id === props.productSpecData.schema.attribute_values.selected_attribute_values.order)
//     ? props.productSpecData.data.attribute_values.order.find(n => n.id === props.productSpecData.schema.attribute_values.selected_attribute_values.order)
//     : props.productSpecData.data.attribute_values.order[0]

//   const currentColors = {}
//   for (const area in props.productSpecData.data.colors) {
//     for (const color in props.productSpecData.data.colors[area]) {
//       if (props.productSpecData.data.colors[area][color].is_selected) {
//         currentColors[area] = props.productSpecData.data.colors[area][color].color
//       }
//     }
//   }


//   /*
//   * Send Request
//   */
//   await addToCart({
//     'product-id': props.productData.id,
//     'selected_attribute_value': currentAttribute,
//     'selected_quantity': quantity,
//     'selected_colors': currentColors
//   }).then(async () => { 
//     // GTM - Add To Cart
//     emit('returnForGtm', {
//       event: 'add_to_cart',
//       ecommerce: {
//         currency: 'USD',
//         value: props.productData.pre_populated_unit_price * quantity,
//         items: [{
//           index: 0,
//           item_id: props.productData.id,
//           item_name: props.productData.producttitle,
//           price: props.productData.pre_populated_unit_price,
//           quantity: quantity
//         }]
//       }
//     })

//     // Update Cart
//     await getCart()

//     // Redirect
//     routerPush('/checkout')

//     loadingForm.value = false
//   }).catch(() => {
//     loadingForm.value = false
//   })
// }
</script>

<style lang="scss" scoped>
.cta-form {
  .cta-block-item {
    display: flex;
    align-items: baseline;
    @media only screen and (max-width: 993px) {
      justify-content: center;
    }
  }
  .cta-sample-block {
    width: 100%;
    max-width: 445px;
    margin: 1rem 0 0 !important;
    text-align: left;
    vertical-align: middle;
    .info,
    .price {
      min-height: 100%;
      padding: .5rem 1rem !important;
      border: 1px solid #eaedf0;
    }
  }
}
.btn-separate {
  padding: 0 1rem 0 1rem;
  &.subDescr {
    padding-top: 1.5rem;
    padding-bottom: 2rem;
  }
}
.btn-holder {
  display: flex;
  flex-direction: column;
  padding: .5rem 0;
  .btn {
    width: 100%;
    min-width: inherit!important;
    max-width: 100%;
  }
  span {
    display: block;
    line-height: 2.5;
    white-space: nowrap;
    &.tiny {
      font-size: 11px;
    }
  }
}
</style>
